/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { brandingDataGenerationErrorSchema } from './BrandingDataGenerationErrorSchema'

export const brandingDataSchema = z.object({
	id: z.string().nullable(),
	organisationId: z.string().nullable(),
	name: z.string().nullable(),
	website: z.string().nullable(),
	logoId: z.string().nullable(),
	logo: z.object({
		id: z.string(),
		name: z.string(),
		fileName: z.string(),
		category: z.union([z.literal('image'), z.literal('file')]),
		mimeType: z.string().nullable(),
		size: z.number(),
		humanReadableSize: z.string(),
		url: z.string(),
		collectionName: z.union([
			z.literal('ad-asset'),
			z.literal('baked-story'),
			z.literal('baked-feed'),
			z.literal('story'),
			z.literal('feed'),
			z.literal('landing-page'),
			z.literal('logo'),
			z.literal('generated'),
			z.literal('uploaded'),
			z.literal('imported'),
			z.literal('candidate-files'),
			z.literal('custom-font'),
			z.literal('design'),
			z.literal('whatsapp-profile'),
		]),
		width: z.number(),
		height: z.number(),
		isPlaceholder: z.boolean(),
		isGenerating: z.boolean(),
		createdAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	toneOfVoice: z.string().nullable(),
	visualGuidance: z.string().nullable(),
	cornerRadius: z.string().nullable(),
	background: z.string(),
	foreground: z.string(),
	accentBackground: z.string(),
	accentForeground: z.string(),
	fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }),
	createdAt: z.iso.datetime().nullable(),
	updatedAt: z.iso.datetime().nullable(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
	generateKeyImage: z.boolean().default(true),
	generationError: brandingDataGenerationErrorSchema.nullable(),
})

export type BrandingDataSchema = z.infer<typeof brandingDataSchema>
